import React from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import BackgroundContainer from '../../components/background-container';

import GridWrap from '../../components/grid-wrap';
import SiteFooter from '../../components/site-footer';
import SubHeading from '../../components/sub-heading';
import PillButton from '../../components/pill-button';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

export default () => (
  <div>
    <Helmet title="Cookie Policy" />
    <BackgroundContainer src={RoomImage}>
      <div className={styles.top}>
        <GridWrap>
          <div className={styles.topContent}>
            <h1>Cookie Policy</h1>
          </div>
        </GridWrap>
      </div>
    </BackgroundContainer>

    <GridWrap>
      <div className={styles.content}>
        <p>
          Cookies consist of portions of code installed in the browser that
          assist the Owner in providing the service according to the purposes
          described. Some of the purposes for which the Cookies are installed
          may also require the User's consent.
        </p>

        <h2>
          Technical Cookies and Cookies serving aggregated statistical purposes
        </h2>
        <p>No cookies of this type are used by this application.</p>

        <h2>Other types of Cookies or third-party tools that might use them</h2>
        <p>
          Some of the services listed below collect statistics in aggregated
          form and may not require the consent of the User or may be managed
          directly by the Owner - depending on how they are described - without
          the help of third parties.
        </p>
        <p>
          If any third party operated services are listed among the tools below,
          these may be used to track Users’ browsing habits – in addition to the
          information specified herein and without the Owner’s knowledge. Please
          refer to the privacy policy of the listed services for detailed
          information.
        </p>

        <h3>Analytics</h3>
        <p>
          The services contained in this section enable the Owner to monitor and
          analyze web traffic and can be used to keep track of User behavior.
        </p>

        <h4>Google Analytics (Google Inc.)</h4>
        <p>
          Google Analytics is a web analysis service provided by Google Inc.
          (“Google”). Google utilizes the Data collected to track and examine
          the use of this Application, to prepare reports on its activities and
          share them with other Google services.<br />Google may use the Data
          collected to contextualize and personalize the ads of its own
          advertising network.
        </p>
        <p>Personal Data collected: Cookies and Usage data.</p>

        <p>
          Place of processing: US –{' '}
          <a
            href="https://www.google.com/intl/en/policies/privacy/"
            target="_blank"
          >
            Privacy Policy
          </a>{' '}
          –{' '}
          <a
            href="https://tools.google.com/dlpage/gaoptout?hl=en"
            target="_blank"
          >
            Opt Out
          </a>
        </p>

        <h2>How can I manage the installation of Cookies?</h2>
        <p>
          <span>
            In addition to what is specified in this document, the User can
            manage preferences for Cookies directly from within their own
            browser and prevent – for example – third parties from installing
            them. Through the browser preferences, it is also possible to delete
            Cookies installed in the past, including the Cookies that might
            possibly have saved the consent for the installation of Cookies by
            this website. It is important to note that by disabling all Cookies,
            the functioning of this site may be compromised. Users can find
            information about how to manage Cookies in their browser at the
            following addresses:
          </span>{' '}
          <a
            href="https://support.google.com/chrome/answer/95647?hl=en&p=cpn_cookies"
            rel="nofollow"
            target="_blank"
          >
            Google Chrome
          </a>
          <span>, </span>
          <a
            href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
            rel="nofollow"
            target="_blank"
          >
            Mozilla Firefox
          </a>
          <span>, </span>
          <a
            href="https://support.apple.com/kb/PH19214?viewlocale=en_US&locale=en_US"
            rel="nofollow"
            target="_blank"
          >
            Apple Safari
          </a>
          <span> and </span>
          <a
            href="https://windows.microsoft.com/en-us/windows-vista/block-or-allow-cookies"
            rel="nofollow"
            target="_blank"
          >
            Microsoft Windows Explorer
          </a>
          <span>.</span>
        </p>

        <h2>Data Controller and Owner</h2>
        {/* <p>## TODO : Address, email</p> */}

        <p>
          Since the installation of third party Cookies and other tracking
          systems through the services used within this Application can not be
          technically controlled by the Owner, any specific references to
          Cookies and tracking systems installed by third parties are to be
          considered indicative. In order to obtain complete information,
          consult the privacy policy for the respective third party services
          listed in this document.
        </p>
        <p>
          Given the objective complexity linked to the identification of
          technologies based on Cookies and their very close integration with
          the operation of the web, Users are encouraged to contact the Owner
          should they wish to receive any further information on the use of
          Cookies themselves and any possible use of them - for example, by a
          third party - carried out through this site.
        </p>

        <h2>Legal information</h2>
        <p>
          Notice to European Users: this privacy statement has been prepared in
          fulfillment of the obligations under Art. 10 of EC Directive n.
          95/46/EC, and under the provisions of Directive 2002/58/EC, as revised
          by Directive 2009/136/EC, on the subject of Cookies.
        </p>
        <p>This privacy policy relates solely to this Application.</p>
      </div>
    </GridWrap>
    <SiteFooter />
  </div>
);



// WEBPACK FOOTER //
// ./src/page-components/cookie-policy/index.js